<template>
  <div>
    <AdminHeader></AdminHeader>
      <div class="news_form">
        <span>發布新消息</span>
          <form>
            <div class="form_title">
              <label for="title">標題</label>
            </div>
            <div class="form_content">
              <input id="title" name="title" type="text" v-model="newsInfo.title">
            </div>
            <div class="form_title">
              <label for="time">時間</label>
            </div>
            <div class="form_content">
              <datepicker :clear-button="true" :calendarButton="true" :calendar-button-icon="icon" class="input_date" placeholder="選擇發佈日期" v-model="date"></datepicker>
            </div>
            <div class="form_title title-name">
              <div class="content">內文</div>
            </div>
            <div class="form_content">
              <textarea rows="10" cols="50" v-model="newsInfo.body"></textarea>
            </div>
          </form>
          <button class="release" @click="publish">發佈</button>
          <button class="cancel"><router-link to="/admin/latest_newsList">返回</router-link></button>
      </div>
  </div>
</template>

<script>
import AdminHeader from "@/components/admin/admin_header.vue";
import Datepicker from "vuejs-datepicker";
import "../../scss/_datepicker_plugin.scss";
import axios from "axios";

export default {
  name: "admin_create_news",
  components: {
    AdminHeader,
    Datepicker
  },
  data() {
    return {
      icon: "fa fa-calendar",
      date: "",
      newsInfo: {
        title: "",
        created_at: "",
        body: ""
      },
      //防止狂點
      publishIng: false
    };
  },
  methods: {
    publish() {
      if (this.examineData()) {
        if (this.publishIng) {
          return;
        }
        this.publishIng = true;
        let month = this.zeroFill((this.date.getMonth() + 1).toString(), 2);
        let day = this.zeroFill(this.date.getDate().toString(), 2);
        this.newsInfo.created_at =
          this.date.getFullYear() + "-" + month + "-" + day;
        axios({
          url: this.$store.getters.getGlobalUrl + "admin/news",
          method: "post",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          data: this.newsInfo
        })
          .then(() => {
            alert("發佈成功");
            this.$router.push("/admin/latest_newsList");
          })
          .catch(e => {
            alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
          });
      }
    },
    examineData() {
      if (this.newsInfo.title == "") {
        alert("您的標題尚未填寫");
        return false;
      } else if (this.date == "" || this.date == null) {
        alert("您的日期尚未選取");
        return false;
      } else if (this.newsInfo.body == "") {
        alert("您的內容尚未填寫");
        return false;
      }
      if (this.newsInfo.title.length > 100) {
        alert("您的標題長度過長，請重新修改");
        return false;
      }
      if (this.newsInfo.body.length > 10000) {
        alert("您的標題長度過長，請重新修改");
        return false;
      }
      return true;
    },
    zeroFill(now, fillLength) {
      if (now.length < fillLength) {
        let fillNum = fillLength - now.length + 1;
        return new Array(fillNum).join("0").concat(now);
      }
      return now;
    }
  }
};
</script>

<style scoped lang="scss">
.news_form {
  padding: 50px;
  form {
    display: grid;
    grid-template-columns: 50px 1fr;
    margin-top: 30px;
    .content {
      display: inline;
    }
  }
  .title-name {
    margin-top: 15px;
  }
  .form_content {
    align-self: center;
  }
  label {
    font-size: 17px;
    letter-spacing: 2px;
    color: #4a4a4a;
    line-height: 4;
  }
  input {
    height: 35px;
  }
  .vdp-datepicker input {
    height: 39px;
  }
  .form_content textarea {
    margin-top: 15px;
  }
  input,
  textarea,
  .input_date {
    border: 1px #979797 solid;
    font-size: 17px;
    width: 480px;
    margin: 0;
  }
}
span {
  font-size: 20px;
  letter-spacing: 2px;
}
button {
  font-size: 17px;
  width: 120px;
  height: 35px;
  margin-left: 10px;
}
.release {
  margin: 10px 0 0 50px;
  color: #fff;
  background-color: #4a90e2;
  &:hover {
    background-color: darken(#4a90e2, 10%);
  }
}
.cancel {
  border: 1px #ddd solid;
  a {
    color: #4a4a4a;
  }
  &:hover {
    background-color: darken(#fff, 10%);
  }
}
</style>
